export const MFA_CODE_LENGTH = 6
